import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NotificationsService } from '../../../services/notifications.service';

@Component({
  selector: 'app-notitications',
  templateUrl: './notitications.component.html',
  styleUrls: ['./notitications.component.scss'],
})
export class NotiticationsComponent implements OnInit, OnDestroy {
  public isShow = false;
  notificationList: any[] = [];
  private notificationsSub?: Subscription;

  constructor(private readonly notifications: NotificationsService) {}

  ngOnInit(): void {
    this.notificationsSub = this.notifications.notifications$.subscribe((list) => {
      this.notificationList = list;
    });
    this.notifications.startNotificationsPolling();
  }

  ngOnDestroy(): void {
    this.notificationsSub?.unsubscribe();
    this.notifications.stopNotificationsPolling();
  }

  markAsRead(notificationId: number): void {
    this.notifications.markAsRead(notificationId).subscribe(() => {
      this.notifications.getAllNotifications();
    });
  }
}
